<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <main id="renew3_mypage">
      <div class="mypage_back mypage_top">
        <div class="wrapper">
          <h2 class="m-h2">マイページ</h2>
          <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
              class="text-link">旧マイページ</a>にアクセスしてください。</p>

          <div class="my-contents sp">
            <!--メンバー表示-->
            <div class="member_card flex">
              <div class="member_card_left">
                <div class="left01">
                  <p v-if="!$globalVar.isYagiPrime"><a href="/yagiprime_register" id="prime-mypagetop-btn"
                      class="status">一般会員（ヤギプライム会員になる）</a>
                  </p>
                  <p v-else><a href="/mypage/yagiprime" class="status">ヤギプライム会員</a></p>
                  <p class="name"><span>{{ username }}</span> さん</p>
                  <p>（ <span>{{ useremail }}</span> ）</p>
                </div>
                <div class="left02" v-if="false && mypagedata.fontpayment > 0">
                  <p><a href="" class="servicelink">｜<span>フォント未購入</span></a></p>
                </div>
                <div class="left02" v-if="false && mypagedata.fontpayment > 0">
                  <p><a href="" class="servicelink">｜<span>フォント購入済</span></a></p>
                </div>
              </div>
              <div class="member_card_right yagi_info">
                <div class="dialogEnabled messageEnabled">
                  <your-yagi :your-yagi-class="{}"
                    :yagi-options="{ dialogEnabled: true, rubyEnabled: false, messageEnabled: true }"></your-yagi>
                </div>
                <p class="your-yagi-title">あなたのヤギ</p>
              </div>
            </div>
            <a href="/mypage/yagioffer" class="yagiprime_btn_item">
              <span>一般会員でも待つだけでオファーが届く</span>
              <br>ヤギオファーを確認する
            </a>
            <div class="renew2_flex yagiprime_btn_list" v-if="$globalVar.isYagiPrime">
              <a href="/ai/interview_practice" class="yagiprime_btn_item"><span>ヤギプライム会員特典①</span><br>AIと面接練習する(β版)</a>
              <a href="/format/rirekisho_job_change/edit/ai_reason"
                class="yagiprime_btn_item"><span>ヤギプライム会員特典②</span><br>AIで志望動機（履歴書作成）</a>
            </div>
            <div class="renew2_flex yagiprime_btn_list" v-else>
              <a href="/yagiprime_register" class="yagiprime_btn_item"><span>ヤギプライム会員特典①</span><br>AIと面接練習する</a>
              <a href="/format/rirekisho_job_change/edit/ai_reason"
                class="yagiprime_btn_item"><span>ヤギプライム会員特典②</span><br>AIで志望動機（履歴書作成）</a>
            </div>
            <div class="sakusei_history">
              <h3>書式のご利用状況</h3>
              <ul v-if="mypagedata && mypagedata.format_ids">
                <li v-for="(item, index) in mypagedata.format_ids" :key="index"><a
                    :href="'/format/' + item.format_id">{{ getFormatName(item.format_id) }}</a></li>
              </ul>
            </div>


            <mypagemenu-item viewFlag="my"></mypagemenu-item>


            <mypage-carat v-if="!$globalVar.isYagiPrime" :job_list="job_list" :joblistKeyword="joblistKeyword"
              :joblistArea="joblistArea" :search_id="search_id"></mypage-carat>
            <mypage-yagiprime-carat v-if="$globalVar.isYagiPrime" :job_list="yagiprime_job_list"
              :joblistKeyword="joblistKeyword" :joblistArea="joblistArea"
              :search_id="search_id"></mypage-yagiprime-carat>


            <mypagemenu-item viewFlag="service"></mypagemenu-item>

            <!--求人リスト-->
            <div>

            </div>
          </div>

          <div class="my-contents pc flex">
            <div class="menu-column">

              <mypagemenu-item viewFlag="my"></mypagemenu-item>

              <mypagemenu-item viewFlag="service"></mypagemenu-item>
            </div>

            <div class="right-contents">
              <div class="member_card flex">
                <div class="member_card_left">
                  <div class="left01">
                    <p v-if="!$globalVar.isYagiPrime"><a href="/yagiprime_register" class="status"
                        id="prime-mypagetop-btn">一般会員（ヤギプライム会員になる）</a>
                    </p>
                    <p v-else><a href="/mypage/yagiprime" class="status">ヤギプライム会員</a></p>
                    <p class="name"><span>{{ username }}</span> さん</p>
                    <p>（ <span>{{ useremail }}</span> ）</p>
                  </div>
                  <div class="left02" v-if="false && mypagedata.fontpayment > 0">
                    <p><a href="" class="servicelink">｜<span>フォント未購入</span></a></p>
                  </div>
                  <div class="left02" v-if="false && mypagedata.fontpayment > 0">
                    <p><a href="" class="servicelink">｜<span>フォント購入済</span></a></p>
                  </div>
                </div>
                <div class="member_card_right yagi_info">
                  <div class="dialogEnabled messageEnabled">
                    <your-yagi :your-yagi-class="{}"
                      :yagi-options="{ dialogEnabled: true, rubyEnabled: false, messageEnabled: true }"></your-yagi>
                  </div>
                  <p class="your-yagi-title">あなたのヤギ</p>
                </div>
              </div>
              <a href="/mypage/yagioffer" class="yagiprime_btn_item">
                <span>一般会員でも待つだけでオファーが届く</span>
                <br>ヤギオファーを確認する
              </a>
              <div class="renew2_flex yagiprime_btn_list" v-if="$globalVar.isYagiPrime">
                <a href="/ai/interview_practice"
                  class="yagiprime_btn_item"><span>ヤギプライム会員特典①</span><br>AIと面接練習する(β版)</a>
                <a href="/format/rirekisho_job_change/edit/ai_reason"
                  class="yagiprime_btn_item"><span>ヤギプライム会員特典②</span><br>AIで志望動機（履歴書作成）</a>
              </div>
              <div class="renew2_flex yagiprime_btn_list" v-else>
                <a href="/yagiprime_register" class="yagiprime_btn_item"><span>ヤギプライム会員特典①</span><br>AIと面接練習する</a>
                <a href="/format/rirekisho_job_change/edit/ai_reason"
                  class="yagiprime_btn_item"><span>ヤギプライム会員特典②</span><br>AIで志望動機（履歴書作成）</a>
              </div>
              <div class="sakusei_history">
                <h3>書式のご利用状況</h3>
                <ul v-if="mypagedata && mypagedata.format_ids">
                  <li v-for="(item, index) in mypagedata.format_ids" :key="index"><a
                      :href="'/format/' + item.format_id">{{ getFormatName(item.format_id) }}</a></li>
                </ul>
              </div>

              <mypage-carat v-if="!$globalVar.isYagiPrime" :job_list="job_list" :joblistKeyword="joblistKeyword"
                :joblistArea="joblistArea" :search_id="search_id"></mypage-carat>
              <mypage-yagiprime-carat v-if="$globalVar.isYagiPrime" :job_list="yagiprime_job_list"
                :joblistKeyword="joblistKeyword" :joblistArea="joblistArea"
                :search_id="search_id"></mypage-yagiprime-carat>


            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>
<style scoped>
#renew3_mypage .popup_block {
  text-align: center;
  position: relative;
  z-index: 1;
}

#renew3_mypage .txt02 {
  font-size: 1rem;
  line-height: 1.5;
  margin: 5px 0;
}

#renew3_mypage .txt03 {
  display: inline-block;
  position: relative;
  font-weight: bold;
}

#renew3_mypage .txt03::before {
  position: absolute;
  content: "";
  background: #fff620;
  height: 8px;
  width: 110%;
  bottom: 2px;
  left: -5%;
  z-index: -1;
}

#renew3_mypage .carat_block {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_carat_h3 {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_carat_h3_span {
  font-size: 1rem;
  color: #E95B10;
}

#renew3_mypage .joblist_carat_h3_word {
  display: inline-block;
  color: #fff;
  background: #004d40;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

#renew3_mypage .joblist_carat_link {
  font-size: 0.8rem;
}

#renew3_mypage .joblist_link {
  background: #fff;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.17);
}

#renew3_mypage .carat_link:hover {
  text-decoration: none;
  opacity: 1;
}

#renew3_mypage .joblist_link01 {
  align-items: center;
  margin-bottom: 10px;
}

#renew3_mypage .txt_category {
  background: #0f9934;
  color: #fff;
  border-radius: 50px;
  padding: 2px 10px;
  margin-right: 5px;
  font-size: .65rem;
  font-weight: bold;
  white-space: nowrap;
}

#renew3_mypage .joblist_link02 {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_h4 {
  color: #004d40;
  line-height: 1.4;
  font-size: 1rem;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

#renew3_mypage .joblist_company {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 5px;
}

#renew3_mypage .txt_area,
#renew3_mypage .joblist_salary {
  position: relative;
  margin-left: 25px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

#renew3_mypage .txt_area::before {
  position: absolute;
  content: "";
  background-image: url(/txt_area.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  left: -20px;
  top: calc(50% - 8px);
}

#renew3_mypage .joblist_salary::before {
  position: absolute;
  content: "";
  background-image: url(/joblist_salary.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  left: -20px;
  top: calc(50% - 8px);
}

#renew3_mypage .joblist_keywordlist {
  flex-wrap: wrap;
  margin-bottom: 5px;
}

#renew3_mypage .joblist_keyworditem {
  margin: 0 5px 5px 0;
  border: 1px solid #BFBFBF;
  border-radius: 50px;
  padding: 1px 10px;
  font-size: 0.75rem;
  font-weight: bold;
}

#renew3_mypage .joblist_summary {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_summary .joblist_txt {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 0.8rem;
  color: #999999;
}

#renew3_mypage .joblist_img {
  width: 100px;
  height: auto;
  object-fit: cover;
  margin-left: 10px;
}

#renew3_mypage .joblist_button {
  align-items: center;
  justify-content: space-between;
}

#renew3_mypage .joblist_detail_link,
#renew3_mypage .carat_btn {
  width: calc(100% / 2 - 5px);
  font-weight: bold;
  background: #fff;
  border: 1px solid #D1345E;
  padding: 12px 0;
}

#renew3_mypage .joblist_detail_link {
  padding: 12px 20px;
  border-radius: 4px;
  color: #D1345E;
}

#renew3_mypage .carat_btn {
  background: #D1345E;
  border-color: #D1345E;
}

#renew3_mypage .consent-link {
  color: #347CD4;
}

#renew3_mypage .consent-txt {
  justify-content: center;
  align-items: center;
}

#renew3_mypage .consent-icon {
  width: auto;
  height: 16px;
  object-fit: cover;
  margin-right: 5px;
}

@media screen and (max-width: 640px) {
  #renew3_mypage .joblist_button {
    display: block;
  }

  #renew3_mypage .joblist_detail_link,
  #renew3_mypage .carat_btn {
    width: 100%;
  }

  #renew3_mypage .joblist_detail_link {
    margin-bottom: 10px;
  }
}
</style>
<style scoped>
#renew3_mypage .sakusei_history {
  background: #fff;
  padding: 15px;
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .25);
  box-shadow: 0 0 4px rgba(0, 0, 0, .25);
  border-radius: 10px;
  margin-bottom: 20px;
}

#renew3_mypage .sakusei_history h3 {
  color: #0f9934;
  font-size: 1rem;
  margin-bottom: 10px;
}

#renew3_mypage .sakusei_history li:before {
  content: "\25CF";
  color: #004d40;
  margin-right: 5px;
}
</style>
<style scoped>
#renew3_mypage .yagiprime_btn_list {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  text-align: center;
  flex-wrap: wrap;
}

#renew3_mypage .yagiprime_btn_item {
  position: relative;
  overflow: hidden;
  z-index: 1;
  width: calc(50% - 10px);
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
}

#renew3_mypage .yagiprime_btn_item::before {
  content: "";
  width: 10px;
  height: 10px;
  border: 0;
  border-bottom: 2px solid #0f9934;
  border-right: 2px solid #0f9934;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;
}

#renew3_mypage .yagiprime_btn_item::after {
  background: #8fbd67;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  width: 100%;
  height: 100%;
  transform: scale(0, 1);
  transform-origin: left top;
  transition: .2s cubic-bezier(0.45, 0, 0.55, 1);
  z-index: -1;
}

#renew3_mypage .yagiprime_btn_item:hover {
  color: #fff;
  text-decoration: none;
  opacity: 1;
}

#renew3_mypage .yagiprime_btn_item:hover::before {
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
}

#renew3_mypage .yagiprime_btn_item:hover::after {
  transform: scale(1, 1);
}

#renew3_mypage .yagiprime_btn_item span {
  font-weight: bold;
  font-size: 12px;
}

@media screen and (max-width: 640px) {
  #renew3_mypage .yagiprime_btn_item {
    display: block;
    width: 100%;
  }

  #renew3_mypage .yagiprime_btn_item:first-child {
    /* margin-bottom: 10px; */
  }
}
</style>
<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import MyPageCarat from './parts/MyPageCaratPart'
import MyPageYagiprimeCarat from './parts/MyPageYagiprimeCaratPart'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'mypage-carat': MyPageCarat,
    'mypage-yagiprime-carat': MyPageYagiprimeCarat,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    'mypagemenu-item': MypageCommonMenu,
    Slick
  },
  data: function () {
    return {
      fullscreenLoading: false,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible: false,
      username: '',
      useremail: '',
      selectedYagiOfferData: {},
      selectedQuickEmailData: {},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      joblistKeyword: '',
      joblistArea: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      job_list: [],
      yagiprime_job_list: [],
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho',
      search_id: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getFormatName: function (format_id) {
      for (let p of this.$site.formatsIndex) {
        if (p.id == format_id) {
          return p.title
        }
      }
      for (let p of this.$site.keirekishoFormatsIndex) {
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    clickJob: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', 'mypage')
      formData.append('keyword', this.joblistKeyword)
      formData.append('area', this.joblistArea)


      formData.append('jt', _item.jt)
      formData.append('st', _item.st)
      formData.append('title', _item.title)
      formData.append('company', _item.company)
      formData.append('snippet', _item.snippet)
      formData.append('clicklink', _item.url)


      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, { timeout: 60000 })
    },
    clickCarat: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.search_id = ''
      this.$eventHub.$emit('open-carat-dialog', 'mypage', null, this.joblistKeyword, this.joblistArea, null, 2, _item, this.search_id)


      // const formData = new FormData()
      // formData.append('uuid', this.$firebase.user.uid)
      // formData.append('format_id', 'mypage')
      // formData.append('occupation', '正社員')

      // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      // formData.append('version', '2')
      // formData.append('site_flag', 'r')
      // formData.append('app_flag', this.$site.appFlag)

      // const app = this
      // this.$axios.post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
    },
    applicantCarat: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      } else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, { timeout: 60000 })
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id == jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applicantCarat4Confirm: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      // if(!confirm('本当に応募しますか？')) {
      //   return
      // }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      } else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, { timeout: 60000 })
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id == jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEmailVerification: async function () {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '送信しました。メール内のリンクをクリックしてください',
          type: 'success'
        })

      }).catch((error) => {
        app.$message({
          message: '送信失敗しました。',
          type: 'error'
        })
      })
    },
    authStateChanged: async function () {
      const app = this

      app.fullscreenLoading = true
      this.$iterateStorage(function (value, key, iterationNumber) {
        if (key === 'basicData') {
          app.formatData = value
        }
      }, function (err) { })

      console.log('mypage logined')
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('version', '2')
      formData.append('reqflg', '2')
      formData.append('email', this.$firebase.user.email)
      formData.append('site_flag', 'r')
      formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('email_verified', this.$firebase.user.emailVerified ? '1' : '0')

      app.$axios
        .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
        .then(function (response) {
          app.mypagedata = response.data
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else if (app.mypagedata.memberdata.lastname) {
            app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
          console.error(app.mypagedata.memberdata.offers)
          app.joblistKeyword = app.mypagedata.memberdata.keyword
          app.joblistArea = app.mypagedata.memberdata.area
          app.job_list = app.mypagedata.memberdata.offers.offers
          app.search_id = app.mypagedata.memberdata.offers.search_id

        })
        .catch(function (error) {
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })

      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          if (response.data.is_subscribed) {

            app.$axios
              .post(app.$varuna.endPoints.subscriptionsMypage, formData, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                let _joblist = response.data.recommended_jobs
                for (let _key in _joblist) {
                  let _job = _joblist[_key]
                  if (!_job.applied_date && !_job.cancel_date) {
                    app.yagiprime_job_list.push(_job)

                  }

                }
              })
              .catch(function (error) {
              }).finally(function () {
                app.fullscreenLoading = false
              })
          }
          //yagiprime_job_list
        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {

    const app = this

    app.$cookies.config(60 * 60 * 24, '')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', 'mypage', null, null, 'yagish.jp')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', 'mypage', null, null, 'localhost')

    if (this.$route.query.custom_token) {

      firebase.auth().signInWithCustomToken(this.$route.query.custom_token)
        .then((userCredential) => {
          let user = userCredential.user
          if (user) {
            console.log('mypage logined')
            const formData = new FormData()
            formData.append('uuid', user.uid)
            formData.append('version', '2')
            formData.append('reqflg', '2')
            formData.append('email', user.email)
            formData.append('site_flag', 'r')
            formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('email_verified', user.emailVerified ? '1' : '0')

            app.$axios
              .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
              .then(function (response) {
                app.mypagedata = response.data
                if (app.$firebase.user.displayName) {
                  app.username = app.$firebase.user.displayName
                  app.useremail = app.$firebase.user.email
                } else if (app.mypagedata.memberdata.lastname) {
                  app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                  app.useremail = app.$firebase.user.email
                } else {
                  app.username = app.$firebase.user.email
                }
                console.error(app.mypagedata.memberdata.offers)
                app.joblistKeyword = app.mypagedata.memberdata.keyword
                app.joblistArea = app.mypagedata.memberdata.area
                app.job_list = app.mypagedata.memberdata.offers.offers
                app.search_id = app.mypagedata.memberdata.offers.search_id

              })
              .catch(function (error) {
                if (app.$firebase.user.displayName) {
                  app.username = app.$firebase.user.displayName
                  app.useremail = app.$firebase.user.email
                } else {
                  app.username = app.$firebase.user.email
                }
              }).finally(function () {
              })

            app.fullscreenLoading = false

          }


        })
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          console.error(errorCode + errorMessage)

        })
    } else {
      // console.log(this.$route.query.mynavi)
      // firebase.auth().onAuthStateChanged((user) => {
      //   console.log('mypage onAuthStateChanged')
      //   if (user) {
      //     console.log('mypage logined')
      //     const formData = new FormData()
      //     formData.append('uuid', user.uid)
      //     formData.append('version', '2')
      //     formData.append('reqflg', '2')
      //     formData.append('email', user.email)
      //     formData.append('site_flag', 'r')
      //     formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      //     formData.append('email_verified', user.emailVerified ? '1' : '0')
      //     var affiliate_id = this.$cookies.get('_YAGISH_AFFILIATE_ID')
      //     if (affiliate_id) formData.append('affiliate_id', affiliate_id)

      //     app.$axios
      //       .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
      //       .then(function (response) {
      //         app.mypagedata = response.data
      //         if (app.$firebase.user.displayName) {
      //           app.username = app.$firebase.user.displayName
      //           app.useremail = app.$firebase.user.email
      //         } else if (app.mypagedata.memberdata.lastname) {
      //           app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
      //           app.useremail = app.$firebase.user.email
      //         } else {
      //           app.username = app.$firebase.user.email
      //         }
      //         console.error(app.mypagedata.memberdata.offers)
      //         app.joblistKeyword = app.mypagedata.memberdata.keyword
      //         app.joblistArea = app.mypagedata.memberdata.area
      //         app.job_list = app.mypagedata.memberdata.offers.offers
      //         app.search_id = app.mypagedata.memberdata.offers.search_id

      //       })
      //       .catch(function (error) {
      //         if (app.$firebase.user.displayName) {
      //           app.username = app.$firebase.user.displayName
      //           app.useremail = app.$firebase.user.email
      //         } else {
      //           app.username = app.$firebase.user.email
      //         }
      //       }).finally(function () {
      //       })

      //     app.fullscreenLoading = false

      //   } else {
      //     console.log('mypage login')
      //     app.$router.push('/login')
      //   }
      // })
    }
  },
  beforeMount: function () {
    console.error("beforeMount:" + this.$route.query.custom_token)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
